<!--  -->
<template>
  <div class="lunbuo">
    <div
      id="carousel-example-generic"
      class="carousel slide"
      data-ride="carousel"
      data-interval="3000"
      data-pause="hover"
      data-keyboard="true"
      data-wrap="true"
    >
      <!-- Indicators -->
      <ol class="carousel-indicators">
        <li data-target="#carousel-example-generic" data-slide-to="0" class="active"></li>
        <li data-target="#carousel-example-generic" data-slide-to="1"></li>
      </ol>

      <!-- Wrapper for slides -->
      <div class="carousel-inner" role="listbox">
        <div class="item active har" style=" width: 100%; ">
          <img style=" width: 100%; height:100%" src="../assets/image/banner.png" alt="..." />
          <div class="carousel-caption abnui">
            <h3>智选云商</h3>
            <h4>让3C零售更便捷</h4>
            <p class="p1">
              <button @click="emitEvent">免费试用</button>
            </p>
            <p class="p2">咨询热线:15617953373</p>
          </div>
        </div>
        <div class="item har" style=" width: 100%; ">
          <img style=" width: 100%; height:100%" src="../assets/image/banner21.png" alt="..." />
          <!-- <div class="carousel-caption">
        ...
          </div>-->
        </div>
      </div>

      <!-- Controls -->
      <a
        class="left carousel-control"
        href="#carousel-example-generic"
        role="button"
        data-slide="prev"
      >
        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="right carousel-control"
        href="#carousel-example-generic"
        role="button"
        data-slide="next"
      >
        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>


<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    emitEvent() {
      this.$emit("my-event");
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.carousel-control {
  width: 7%;
}
.glyphicon{
  font-family: 'Glyphicons Halflings' !important;
}
.har {
  height: 420px;
}
.carousel-caption {
  color: red;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0);
}
.lunbuo {
  width: 100%;
  height: 420px;
  margin-top: 70px;
  // border: 1px solid red;
  .abnui {
    width: 1200px;
    height: 420px;
    margin: 0px auto;
    text-align: left;
    // border: 1px solid red;
    padding-left: 50px;
    h3 {
      margin-top: 106px;
      font-size: 44px;
      padding-left: 1px;
      color: #333333;
    }
    h4 {
      margin-top: 28px;
      font-size: 25px;
      color: #656565;
    }
    .p1 {
      margin-top: 53px;
      font-size: 18px;
      color: #ffffff;
      button {
        &:focus {
          outline: medium;
        }
        
      }
    }

    .p2 {
      margin-top: 21px;
      font-size: 14px;
      color: #656565;
    }
    button {
      background-color: #3366ff;
      height: 50px;
      width: 160px;
      border: 0px;
      transition: background 2s;
    }
    button:hover{
  background-color: #1344d8 !important;
}
    // .carousel-caption{
    //   // margin-top: 20px;
    //   padding-bottom: 110px;
    // }
    .carousel .slide {
      width: 100% !important;
    }
  }
}
@media screen and (max-width: 1600px) {
  .lunbuo {
    width: 100%;
    margin: 0px auto;
    margin-top: 70px;
    height: 380px;
    // border: 1px solid black;
    .abnui {
      width: 1200px;
      height: 400px;
      margin: 0px auto;
      margin-left: -100px;
      text-align: left;
      h3 {
        margin-top: 118px;
        font-size: 40px;
        padding-left: 1px;
        color: #333333;
      }
      h4 {
        margin-top: 25px;
        font-size: 20px;
        color: #656565;
      }
      .p1 {
        margin-top: 53px;
        font-size: 15px;
        color: #ffffff;
        button {
          &:focus {
            outline: medium;
          }
        }
      }

      .p2 {
        margin-top: 21px;
        font-size: 14px;
        color: #656565;
      }
      button {
        background-color: #3366ff;
        height: 50px;
        width: 150px;
        border: 0px;
        transition: background 2s;
      }
    }
  }
  .har {
    height: 340px;
  }
}
@media screen and (max-width: 1500px) {
  .lunbuo {
    width: 100%;
    margin: 0px auto;
    margin-top: 70px;
    height: 370px;
    // border: 1px solid black;
    .abnui {
      width: 1200px;
      height: 400px;
      margin: 0px auto;
      margin-left: -100px;
      text-align: left;
    }
  }
  .har {
    height: 330px;
  }
}

@media screen and (max-width: 1400px) {
  .lunbuo {
    width: 100%;
    margin: 0px auto;
    margin-top: 70px;
    height: 360px;
    // border: 1px solid black;
    // height: 300px;
    .abnui {
      width: 800px;
      height: 400px;
      margin: 0px auto;
      margin-left: -100px;
      text-align: left;
      h3 {
        margin-top: 152px;
        font-size: 30px;
        padding-left: 1px;
        color: #333333;
      }
      h4 {
        margin-top: 20px;
        font-size: 20px;
        color: #656565;
      }
      .p1 {
        margin-top: 40px;
        font-size: 14px;
        color: #ffffff;
        button {
          &:focus {
            outline: medium;
          }
        }
      }

      .p2 {
        margin-top: 21px;
        font-size: 14px;
        color: #656565;
      }
      button {
        background-color: #3366ff;
        height: 40px;
        width: 120px;
        border: 0px;
        transition: background 2s;
      }
    }
  }
  .har {
    height: 320px;
  }
}
@media screen and (max-width: 1300px) {
  .lunbuo {
    width: 100%;
    margin: 0px auto;
    margin-top: 70px;
    height: 300px;
    // border: 1px solid black;
    // height: 300px;
    .abnui {
      width: 800px;
      height: 400px;
      margin: 0px auto;
      margin-left: -100px;
      text-align: left;
    }
  }
  .har {
    height: 310px;
  }
}
@media screen and (max-width: 1200px) {
  .lunbuo {
    width: 100%;
    margin-top: 70px;
    height: 300px;
    // border: 1px solid red;
    // height: 300px;
    .abnui {
      width: 800px;
      height: 380px;
      margin: 0px auto;
      margin-left: -100px;
      text-align: left;
      h3 {
        margin-top: 132px;
        font-size: 30px;
        padding-left: 1px;
        color: #333333;
      }
      h4 {
        margin-top: 20px;
        font-size: 20px;
        color: #656565;
      }
      .p1 {
        margin-top: 40px;
        font-size: 14px;
        color: #ffffff;
        button {
          &:focus {
            outline: medium;
          }
        }
      }

      .p2 {
        margin-top: 21px;
        font-size: 14px;
        color: #656565;
      }
      button {
        background-color: #3366ff;
        height: 40px;
        width: 120px;
        border: 0px;
        transition: background 2s;
      }
    }
  }
  .har {
    height: 300px;
  }
}
</style>